module.exports = {
      id: "mail-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#mail",
      toString: function () {
        return this.url;
      }
    }